import React, { useState, useEffect } from 'react';
import '../Assets/Css/contact.css';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaUserTie } from 'react-icons/fa';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        userName: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        address: formData.address,
        message: formData.message
      };

      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, payload);

      toast.success(response.data.message || 'Message sent successfully');
      setFormData({ name: '', mobile: '', email: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mainnav min-vh-100">

       <Helmet>
        <title>Contact Us | Pradh Management Solutions</title>
        <meta name="description" content="Get in touch with Pradh Management Solutions. Contact Mr. Dhiraj Lohar (CEO) for infrastructure and facility management services in Pune." />
        <meta name="keywords" content="Pradh Management, Facility Management, Contact Dhiraj Lohar, Infrastructure Services, Pune Services" />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://pradh.com/contact" />

        {/* Open Graph for Social Media */}
        <meta property="og:title" content="Contact Pradh Management Solutions" />
        <meta property="og:description" content="Reach out to us for specialized infrastructure and facility management solutions in Pune." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pradh.com/contact" />
        <meta property="og:image" content="https://pradh.com/images/contact-preview.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Pradh Management Solutions" />
        <meta name="twitter:description" content="We are committed to your service. Get in touch with our CEO Mr. Dhiraj Lohar." />
        <meta name="twitter:image" content="https://pradh.com/images/contact-preview.jpg" />
      </Helmet>

      <Toaster />

      {/* Hero Section */}
      <section className="hero-section7">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Contact Us</h1>
          <p data-aos="zoom-in" data-aos-delay="100">We are committed to your service</p>
          <a href="#contact-details" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Get in Touch</a>
        </div>
      </section>

      {/* Contact Details */}
      <section id="contact-details" className="mt-5 ">
        <Container>
          <Row className="mb-4">
            <Col md={12} className="text-center" data-aos="zoom-in" data-aos-delay="100">
              <h2>
                <span className="contactmaintitle"> Pradh </span>
                {' '}

                <br />

                <span style={{ color: 'black', letterSpacing: '2px', fontWeight: 'bold', fontSize: '28px' }}>Management Solutions </span>

              </h2>

            </Col>
          </Row>
        </Container>
      </section>

      <Container className="py-4">
        <Row className="g-4" data-aos="zoom-in" data-aos-delay="200">
          {/* CEO Name Card */}
          <Col xs={12} md={6} lg={3}>
            <div className="info-card p-4 shadow rounded text-center h-100">
              <FaUserTie size={30} className="mb-3 text-warning" />
              <h5 className="fw-bold mb-2" style={{color:'#04A1D3'}}>CEO </h5>
              <h6 className=" mb-0">Mr. Dhiraj Lohar</h6>
            </div>
          </Col>
          {/* Mobile Number Card */}
          <Col xs={12} md={6} lg={3}>
            <div className="info-card p-4 shadow rounded text-center h-100">
              <FaPhoneAlt size={30} className="mb-3 text-primary" />
              <h5 className="fw-bold mb-2" style={{color:'#04A1D3'}}>Mobile Number</h5>
              <h6 className="mb-0 ">+91 8482922662</h6>
            </div>
          </Col>

          {/* Email Card */}
          <Col xs={12} md={6} lg={3}>
            <div className="info-card p-4 shadow rounded text-center h-100">
              <FaEnvelope size={30} className="mb-3 text-success" />
              <h5 className="fw-bold mb-2" style={{color:'#04A1D3'}}>Email</h5>
              <h6 className="mb-0">pradhmspl@gmail.com</h6>
            </div>
          </Col>


          {/* Address Card */}
          <Col xs={12} md={6} lg={3}>
            <div className="info-card p-4 shadow rounded text-center h-100">
              <FaMapMarkerAlt size={30} className="mb-3 text-danger" />
              <h5 className="fw-bold mb-2" style={{color:'#04A1D3'}}>Address</h5>
              <h6 className="mb-0">
                REGUS,
                6th Floor Pentagon P-2, Magarpatta City, Hadapsar, Pune, Maharashtra, India 13
              </h6>
            </div>
          </Col>
        </Row>
      </Container>

      <section className="contact1-section">
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col xs={12} md={8} lg={8} className="d-flex">
              <div className="contact-form-card">
                <h3 className="mb-3 text-center text-orange">Contact Form</h3>
                <Form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter your name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formMobile">
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter your mobile number"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          pattern="[0-9]{10}"
                          required
                          maxLength={10}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          placeholder="Enter your address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3" controlId="formMessage">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Your message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <div className="mt-auto text-center">
                    <Button className="btn-gett" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" role="status" className="me-2" />
                          Sending...
                        </>
                      ) : (
                        'Send Message'
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>



      <section className="map-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={12}>

              <h2 className="page-title" data-aos="fade-up"> Find Us on Map</h2>
              <div className="map-responsive">
               <iframe 
               title="Pradh Management Solutions"
               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.3794099010247!2d73.92305727519145!3d18.51174908258005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1f294b664c9%3A0x597a294f46632421!2sRegus%20-%20Pune%20Magarpatta%20City!5e0!3m2!1sen!2sin!4v1750221372489!5m2!1sen!2sin" 
               width="100%"
               height="450" 
               allowfullscreen=""
               loading="lazy" 
               referrerpolicy="no-referrer-when-downgrade">
                </iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
